// The host app's global, same one MyAccountClient has always used. Present on the
// client platform only.
declare const $: { iqLogOff(): void };

// The two platforms whose logout path this library actually knows. Deliberately
// not a default-to-something: the required Act As gate offers a sign-out as its
// only non-impersonation exit, and an exit that silently does nothing is worse
// than no exit at all. A host on another platform gets no control rather than a
// broken one, so add its case here before wiring it up.
export const canLogOff = (platform?: string) =>
	platform === 'client' || platform === 'social';

// The logout side effects in one place: drop the acting-as role, then hand off to
// whichever mechanism the platform uses. The two differ entirely -- client goes
// through the host's jQuery plugin, social navigates -- which is why this takes
// the platform rather than assuming one.
//
// Callers: both account menus' Logout rows, the banner's stop-acting-as on social
// (which is a logout there), and the required Act As gate's sign-out -- that last
// one exists because the gate's backdrop covers the nav and the menu row with it.
//
// No in-flight guard here on purpose, and callers do not all need one. It matters
// where the platform's logout issues a revocable request -- the client path's
// doLogout, which a second click duplicates -- so MyAccountClient and the required
// gate's sign-out each hold a ref. Social is exempt: it only assigns
// window.location, and repeating that navigation costs nothing. A shared
// module-level flag would leak between surfaces and across tests.
const logOff = (platform?: string, { parentStopActing = false } = {}) => {
	localStorage.removeItem('CurrentActingAsROLE');

	if (platform === 'social') {
		// The banner's "stop acting as" on social is a logout too, and it carries
		// this flag. Kept here rather than at the call site so the URL and the
		// storage clear have one definition between them.
		window.location.href = `/site/logout${parentStopActing ? '?parent-stop-acting=1' : ''}`;

		return;
	}

	$.iqLogOff();
};

export default logOff;
